import { passThroughAxios } from './passThrough.axios'

export default {
  getQuoteInfo(quoteId) {
    return passThroughAxios.get(`admin/tools/quote/${quoteId}`)
  },
  getStockInfo(commissionNumber) {
    return passThroughAxios.get(`admin/tools/stock/commission/${commissionNumber}`)
  },
  replaceVehicleWithBaseline(stockBrand, commissionNumber, commissionNumberYear) {
    return passThroughAxios.post(
      `admin/tools/stock/replace-with-baseline/${stockBrand}/${commissionNumber}/${commissionNumberYear}`
    )
  },
}
